import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { TestInCenter } from 'src/app/_models/center-test.model';
import { HomeVisitFee } from 'src/app/_models/homeVisitFees.model';
import { AreaService } from 'src/app/_services/area.service';
import { CentersService } from 'src/app/_services/centers.service';

@Component({
  selector: 'app-home-visit-fees',
  templateUrl: './home-visit-fees.component.html',
  styleUrls: ['./home-visit-fees.component.scss'],
})
export class HomeVisitFeesComponent implements OnInit {
  pageTitle: string = 'Home Fees';
  pageLink: string = '';
  homeVisitFee: HomeVisitFee = {};
  areasArray: [];
  editMode = false;
  addFeesForm: FormGroup;
  isSubmited: boolean = false;
  labFileName: string = '';

  constructor(
    private centerService: CentersService,
    private activatedRoute: ActivatedRoute,
    private areaService: AreaService,
    public toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.addFeesForm = this._formBuilder.group({
      feesArea: [null, [Validators.required]],
      feesValue: [null, [Validators.required]],
    });

    let labId = this.activatedRoute.snapshot.url[2];
    this.pageLink = `/centers/homeFeesList/${labId}`;

    this.getAllAreas();

    const centerId = this.activatedRoute.snapshot.params.centerId;
    this.homeVisitFee.centerId = centerId;

    this.editMode =
      this.activatedRoute.snapshot.url[3] &&
      this.activatedRoute.snapshot.url[3].path === 'edit' &&
      true;

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.feeId;
      this.getFeeById(id);
    }
  }

  getFeeById(feesId) {
    this.centerService.getFeeById(feesId).subscribe((res) => {
      this.homeVisitFee = res?.data;

      this.addFeesForm.patchValue({
        feesArea: this.homeVisitFee.areaId,
        feesValue: this.homeVisitFee.homeVisitFees,
      });
    });
  }

  getAllAreas() {
    this.areaService.getAllAreas().subscribe((res) => {
      this.areasArray = res?.data?.areas;
    });
  }

  buildLabObject(data) {
    return {
      update: {
        id: this.homeVisitFee.id,
        homeVisitFees: data.feesValue,
      },
      add: {
        areaId: data.feesArea,
        homeVisitFees: data.feesValue,
        centerId: this.homeVisitFee.centerId
      }
    };
  }

  onAddFeesSubmit() {
    this.isSubmited = true;

    let feesObject = this.buildLabObject(this.addFeesForm.value);

    if (this.addFeesForm.valid) {
      if (this.editMode) {
        this.centerService.updateFee(feesObject.update).subscribe((res) => {

          showNotification(
            'success',
            `Fees has been updated`,
            this.toastr
          );
          this.router.navigateByUrl(this.pageLink);
        });
      } else {
        this.centerService
          .addHomeFeesVisits(feesObject.add)
          .subscribe((res) => {
            showNotification(
              'success',
              `Fees has been added`,
              this.toastr
            );
            this.router.navigateByUrl(this.pageLink);
          });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
